import { render, staticRenderFns } from "./category-edit.vue?vue&type=template&id=4e666050&scoped=true&"
import script from "./category-edit.vue?vue&type=script&lang=js&"
export * from "./category-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e666050",
  null
  
)

export default component.exports